import { Button, Input, Select } from "antd";
import { DataItem, data } from "components/Tables/FinanceRevenuesTable/mock";
import { GeneralFormProvider } from "components/UI/GeneralForm/GeneralFormProvider";
import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { FormItem } from "react-hook-form-antd";

import { AddFinanceCostsFormData, schema } from "./formSchema";

const { Option } = Select;

interface AddFinanceCostsFormProps {
    handleAdd: (newItem: DataItem) => void;
}

const AddFinanceCostsFormContent: FC<AddFinanceCostsFormProps> = ({ handleAdd }) => {
    const { t } = usePaldockTranslation("forms.add-finance-costs");
    const { t: tFields } = usePaldockTranslation("forms.general-fields");
    const { t: tCommon } = usePaldockTranslation("common");
    const generalFormUtils = useGeneralForm<AddFinanceCostsFormData>();
    const { control, handleSubmit, fieldNames } = generalFormUtils;

    const onSubmit = (values: AddFinanceCostsFormData) => {
        const newEntry: DataItem = {
            key: `${data.length + 1}`,
            datum: values.datum,
            uzivatel: values.uzivatel,
            zeme: values.zeme,
            flagCode: values.flagCode,
            kategorie: values.kategorie,
            nabidka: values.nabidka,
            typ: values.typ,
            id: `${data.length + 210}`,
            odmena: values.odmena,
            castka: values.castka,
        };

        handleAdd(newEntry);

        console.log("New Data Entry Added: ", newEntry);
        console.log("Updated Data Array: ", data);
    };

    return (
        <>
            <FormItem control={control} name={fieldNames.datum.name} label={t("fields.date.label")} required>
                <Input placeholder={t("fields.date.placeholder")} />
            </FormItem>
            <FormItem control={control} name={fieldNames.uzivatel.name} label={t("fields.user.label")} required>
                <Input placeholder={t("fields.user.placeholder")} />
            </FormItem>
            <FormItem control={control} name={fieldNames.zeme.name} label={tFields("country.label")} required>
                <Input placeholder={tFields("country.placeholder")} />
            </FormItem>
            <FormItem control={control} name={fieldNames.flagCode.name} label={t("fields.flag_code.label")} required>
                <Input placeholder={t("fields.flag_code.placeholder")} />
            </FormItem>
            <FormItem control={control} name={fieldNames.kategorie.name} label={tFields("category.label")} required>
                <Input placeholder={tFields("category.placeholder")} />
            </FormItem>
            <FormItem control={control} name={fieldNames.nabidka.name} label={tFields("offer.label")} required>
                <Input placeholder={tFields("offer.placeholder")} />
            </FormItem>
            <FormItem control={control} name={fieldNames.typ.name} label={tFields("type.label")} required>
                <Select placeholder={tFields("type.placeholder")}>
                    <Option value="Click">{t("options.click")}</Option>
                    <Option value="Lead">{t("options.lead")}</Option>
                    <Option value="iFrame">{t("options.iframe")}</Option>
                </Select>
            </FormItem>
            <FormItem control={control} name={fieldNames.odmena.name} label={t("fields.reward.label")} required>
                <Input placeholder={t("fields.reward.placeholder")} />
            </FormItem>
            <FormItem control={control} name={fieldNames.castka.name} label={t("fields.amount.label")} required>
                <Input placeholder={t("fields.amount.placeholder")} />
            </FormItem>
            <Button type="primary" onClick={handleSubmit(onSubmit)}>
                {tCommon("add")}
            </Button>
        </>
    );
};

export const AddFinanceCostsForm: FC<AddFinanceCostsFormProps> = ({ handleAdd }) => {
    const defaultValues: AddFinanceCostsFormData = {
        datum: "",
        uzivatel: "",
        zeme: "",
        flagCode: "",
        kategorie: "",
        nabidka: "",
        typ: "Click",
        odmena: "",
        castka: "",
    };

    return (
        <GeneralFormProvider<AddFinanceCostsFormData> schema={schema} defaultValues={defaultValues}>
            <AddFinanceCostsFormContent handleAdd={handleAdd} />
        </GeneralFormProvider>
    );
};
